import './Sidebar.css';

export default function Sidebar({ children }: { children: JSX.Element }) {
    return <div className="Sidebar">{children}</div>;
}
